// import { useEffect } from 'react'; useNavigate
import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  // EstadosOrdenTrabajoEnumChoice,
  useCheckPermissions,
  useLoaders,
} from '@/shared';
import { useGetOrdenTrabajo } from '@/shared/actions/erp';
// import { AlertSeverityEnum } from '@/shared/interfaces';
// import { useUiStore } from '@/store/ui';
import { SaveAuditoriaInstallOT } from '../../../shared/components';
import { returlUrlAuditoriaInstalacionesPage } from '../../tables/AuditoriaInstalacionesOTMainPage/AuditoriaInstalacionesOTMainPage';
// import { useQueryClient } from '@tanstack/react-query';

export type ViewOTInstallRealizadaAuditoriaPageProps = {};

const ViewOTInstallRealizadaAuditoriaPage: React.FC<
  ViewOTInstallRealizadaAuditoriaPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_ordentrabajo);

  // const navigate = useNavigate();

  // const setAlert = useUiStore(s => s.setAlert);
  // const queryClient = useQueryClient();
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOrdenTrabajo(id!);
  useLoaders(isLoading || isRefetching);

  // useEffect(() => {
  //   queryClient.invalidateQueries();
  // }, []);

  // validate state
  // useEffect(() => {
  //   if (!data?.data?.id_orden_trabajo) return;
  //   if (
  //     data?.data?.estado_orden_trabajo !==
  //     EstadosOrdenTrabajoEnumChoice.REALIZADA
  //   ) {
  //     setAlert(
  //       true,
  //       'La orden de trabajo no tiene el estado correcto',
  //       AlertSeverityEnum.error
  //     );
  //     navigate(returlUrlAuditoriaInstalacionesPage);
  //   }
  // }, [data?.data?.id_orden_trabajo]);

  if (isLoading ) return null;
  if (!data?.data?.id_orden_trabajo)
    return <Navigate to={returlUrlAuditoriaInstalacionesPage} />;

  return (
    <SaveAuditoriaInstallOT
      title="Orden de Trabajo | Auditoría"
      ordentrabajo={data.data}
    />
  );
};

export default ViewOTInstallRealizadaAuditoriaPage;
